export default __webpack_public_path__ + "static/media/game_background.bccdadf0.jpg";